export const ICONS_INPUTS = {
    'user': 'icon-user.svg',
    'mail': 'icon-mail.svg',
    'company': 'icon-company.svg',
    'phone': 'icon-cell-phone.svg',
    'security': 'icon-protect.svg'
}

export const DEFAULT_VALUES_FORM = [
    {
        field: 'input',
        name: 'name',
        text: 'Nombre y apellido',
        icon: 'user',
        pattern: `^[A-Za-zÀ-ÿ ,.'-]+$`,
        regex: /^[ a-zA-ZÀ-ÿ\\u00f1\\u00d1]*$/,
        type: 'text',
        maxLength: 100,
        placeholder: '',
        message: 'Ingrese un nombre válido',
        showMessage: false,
        isError: false, 
        isRequired: true,
        isDisabled: false,
        value: '',
    },
    {
        field: 'input',
        name: 'email',
        text: 'Correo electrónico',
        icon: 'mail',
        type: 'email',
        pattern: '(?![_.-])((?![_.-][_.-])[a-zA-Z\d_.-]){0,63}[a-zA-Z\d]@((?!-)((?!--)[a-zA-Z\d-]){0,63}[a-zA-Z\d]\.){1,2}([a-zA-Z]{2,14}\.)?[a-zA-Z]{2,14}',
        regex: /^((\w[^\W]+)[\.\-]?){1,}\@(([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3})|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/gm,
        maxLength: 75,
        placeholder: '',
        message: 'Ingrese un correo válido',
        showMessage: false,
        isError: false, 
        isRequired: true,
        isDisabled: false,
        value: '',
    },
    {
        field: 'input',
        name: 'company',
        text: 'Nombre de la empresa',
        icon: 'company',
        placeholder: '',
        maxLength: 100,
        isError: false, 
        isRequired: true,
        isDisabled: false,
        value: '',
    },
    {
        field: 'phone',
        name: 'phone',
        text: 'Teléfono',
        icon: 'phone',
        placeholder: '55 1234 4567',
        regex: /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im,
        message: 'Ingrese un número de teléfono válido',
        maxLength: 16,
        showMessage: false,
        isError: false, 
        isRequired: true,
        isDisabled: false,
        value: '',
    },
    {
        field: 'select',
        name: 'people',
        text: '¿Cuántas personas deseas prevenir?',
        icon: 'security',
        placeholder: '',
        options: [
            {
                disabled: true,
                selected: true,
                text: '',
                value: '0'
            },
            {
                text: '1 a 10 personas',
                value: '1-10',
            },
            {
                text: '11 a 50 personas',
                value: '11-50',
            },
            {
                text: '51 a 250 personas',
                value: '51-250',
            },
            {
                text: '251 o más',
                value: '251-MORE',
            },
        ],
        isError: false, 
        isDisabled: false,
        isRequired: false,
        value: '0',
    },
];

export const MESSAGES_ERROR = {
    REQUIRED: 'Campos requeridos',
    SERVER: 'Ha ocurrido un error, por favor inténtelo de nuevo más tarde',
    UNKNOWN: 'No se ha podido enviar la información, comprueba tu conexión a internet e intenta de nuevo',
};


// WEBPACK FOOTER //
// ./src/components/Modal/Epicenter/Constants.js